export default function Configure($stateProvider) {
    $stateProvider.state('societes-client', {
        parent: 'common',
        url: '/societes-client',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('societes-client.list', {
        url: '/list',
        template: '<societes></societes>',
        rights: { domain: 'societes', right: 'read', application: 'gestion;laboratoire' },
        params: {
            genre: '2'
        },
        ncyBreadcrumb: {
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETES_CLIENT_LIST" | translate}}'
        },
        navigation: {
            menu: 'donnees_parametres_donnees',
            translate: 'SOCIETES.BREADCRUMBS.SOCIETES_CLIENT_LIST',
            order: 12
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETES_CLIENT_LIST'
    });

    $stateProvider.state('societes-client.niveaux', {
        url: '/niveaux',
        template: '<societe-config-niveaux></societe-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        params: {
            genre: '2'
        },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher societes > niveaux
            parent: 'societes-client.list({genre: "2"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('societes-client.list.detail', {
        url: '/{id}',
        template: '<societe-detail></societe-detail>',
        rights: { domain: 'societes', right: 'read' },
        params: {
            genre: '2'
        },
        ncyBreadcrumb: {
            parent: 'societes-client.list({genre: "2"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('societes-client.new', {
        url: '/new',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'create' },
        params: {
            genre: '2'
        },
        ncyBreadcrumb: {
            parent: 'societes-client.list({genre: "2"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_CLIENT_NEW" | translate}}'
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETE_CLIENT_NEW'
    });

    $stateProvider.state('societes-client.edit', {
        url: '/{id}/edit',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'update' },
        params: {
            genre: '2'
        },
        ncyBreadcrumb: {
            parent: 'societes-client.list({genre: "2"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_CLIENT_EDIT" | translate }}'
        }
    });

    $stateProvider.state('societes-client.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: {
            parentState: 'societes-client.new',
            genre: '2'
        },
        ncyBreadcrumb: {
            parent: 'societes-client.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
